// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.RentalManagerUserPropertyArchiveV2WebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { UserPropertyArchiveV2RequestDto } from '../..';

export const RentalManagerUserPropertyArchiveV2WebApiHandler_archive_Path = '/api/web/v2/users/properties/archive';

/**
 * Archive a listing and its dupes
 */
export const RentalManagerUserPropertyArchiveV2WebApiHandler_archive = (
  postData: UserPropertyArchiveV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyArchiveV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyArchiveV2WebApiHandler_archive_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
